module.exports = __webpack_public_path__ + "static/media/armadillo-logo.ffc0c8db.svg";